export default __webpack_public_path__ + "static/media/circle-check.056855fb.svg";